import { useEffect, useState } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import _ from 'lodash';
import axios from 'axios';
import Waves from '../assets/waves.svg';
import smallWaves from '../assets/small-waves.svg';

const Header = ({ checkUrl, downloadUrl }) => {

    const [token, setToken] = useState('');
    const [email, setEmail] = useState('');
    const [formFilled, setFormFilled] = useState(false);
    const [isAuthorized, setIsAuthorized] = useState(false);
    const [downloadToken, setDownloadToken] = useState('');
    const [details, setDetails] = useState(null);

    useEffect(() => {
        const urlSearchParams = new URLSearchParams(window.location.search);
        const params = Object.fromEntries(urlSearchParams.entries());

        if (params.token) {
            setToken(params.token);
        }

        if (params.email) {
            setEmail(params.email);
        }

    }, []);

    useEffect(() => {
        if (!_.isEmpty(token) && !_.isEmpty(email) && isEmail(email)) {
            setFormFilled(true);
        } else {
            setFormFilled(false);
        }
    }, [token, email]);

    const isEmail = (email) => {
        return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
    }

    const checkAccess = (e) => {
        e.preventDefault();

        axios.post(checkUrl, {
            token: token,
            customer_email: email
        }).then((response) => {

            if (response.data.status === 'success') {
                setIsAuthorized(true);
                setDownloadToken(response.data.download_token);
                setDetails(response.data.details);
            }

        }).catch((error) => {
            console.log(error);
        });

    }

    const downloadFile = (e) => {

    }

    return (
        <header className="header-2">
            <div className="page-header min-vh-85 relative" style={{backgroundImage: 'url(https://images.unsplash.com/photo-1682686581427-7c80ab60e3f3?q=80&w=1400&auto=format&fit=crop)'}}>
                <span className="mask bg-dark opacity-3"></span>

                {!isAuthorized && (
                    <Container>
                        <Row className="z-index-3">
                            <div className="col-lg-5 m-auto z-index-2">
                                <div className="card card-contact card-raised">
                                    <form id="contact-form1">
                                        <div className="card-header text-center pt-4">
                                            <h5 className="card-title text-primary text-gradient">
                                                Downloads
                                            </h5>
                                        </div>
                                        <div className="card-body">
                                            <div className="form-group">
                                                <label>Token</label>
                                                <div className="input-group input-group-sm mb-4">
                                                    <span className="input-group-text"><i className="fa fa-solid fa-key text-secondary"></i></span>
                                                    <input className="form-control" placeholder="Token" value={token} onChange={(e) => setToken(e.target.value)} type="text"/>
                                                </div>
                                            </div>

                                            <div className="form-group">
                                                <label>Email address</label>
                                                <div className="input-group input-group-sm mb-4">
                                                    <span className="input-group-text"><i className="fa fa-solid fa-envelope text-secondary"></i></span>
                                                    <input className="form-control" placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)} type="email"/>
                                                </div>
                                            </div>

                                            <div className="row">
                                                <div className="col-md-6 text-end my-auto ms-auto">
                                                    <button type="submit" onClick={(e) => checkAccess(e)} className={(formFilled) ? 'btn btn-primary btn-round bg-primary mb-0' : 'btn btn-primary btn-round bg-primary mb-0 disabled'}>
                                                        Controleer
                                                    </button>
                                                </div>
                                            </div>

                                        </div>
                                    </form>
                                </div>
                            </div>
                        </Row>
                    </Container>
                )}

                {isAuthorized && (
                    <Container>
                        <Row className="z-index-3">
                            <div className="col-lg-9 m-auto">
                                <div className="card shadow-lg mb-5">
                                    <div className="card-header bg-primary p-5 position-relative">
                                        <h3 className="text-white mb-0">
                                            Download
                                        </h3>
                                        <p className="text-white opacity-8 mb-4">
                                            Geldig tot: {details && details.expires_at}
                                        </p>
                                        <div className="position-absolute w-100 z-index-1 bottom-0 ms-n5">
                                            <img
                                                src={smallWaves}
                                                alt="waves" 
                                                className="img-fluid w-100"
                                                style={{ height: '7vh', minHeight: '50px' }}
                                            />
                                        </div>
                                    </div>
                                    <div className="card-body p-5">

                                        <ul className="nav flex-column bg-white border-radius-lg p-3 position-sticky top-1">
                                            {details && details.file_list.map((file, index) => (
                                                <li className="nav-item" key={index}>
                                                    {file}
                                                </li>
                                            ))}
                                        </ul>

                                    </div>
                                </div>
                            </div>
                        </Row>
                    </Container>
                )}

                <div className="position-absolute w-100 z-index-0 bottom-0">
                    <img src={Waves} alt="waves" className="img-fluid w-100"/>
                </div>

            </div>
        </header>
    )
}

export default Header;
